import { AccountFile, AccountFileType } from '@mews-commander/data-access';

export interface ContractInfoValues {
    contractEndDate: string | null;
    contractStartDate: string | null;
    negotiatedRates: string | null;
}

export interface ContractFileValues extends ContractInfoValues {
    files: FileList;
}

export interface ContractFileType extends Omit<AccountFile, 'data'> {
    data: {
        discriminator: AccountFileType.Contract;
        value: {
            negotiatedRates?: string | null;
            startUtc?: string | null;
            endUtc?: string | null;
        };
    };
}

export const contractFileDataCoProductGuard = (file: ContractFileType | AccountFile): file is ContractFileType =>
    file?.data?.discriminator === AccountFileType.Contract;
